export const typeOptions = [
  { value: 'variable', label: 'Variable' },
  { value: 'fixe', label: 'Fixe' },
  { value: 'autre', label: 'Autre' },
  { value: 'rpo', label: 'RPO' },
];
